import { useTranslation } from "react-i18next";

export default function TutorsPage() {
  const { t } = useTranslation("sidebar");

  return <title>{`${t("tutors")} - Ximly`}</title>;
}
